"use client";

import { useSyncExternalStore } from "react";

let globalIsInteracting = false;
const listeners = new Set<() => void>();

if (typeof window !== "undefined") {
  const updateState = () => {
    if (globalIsInteracting) return;
    globalIsInteracting = true;
    listeners.forEach((l) => l());
  };
  window.addEventListener("scroll", updateState, { once: true });
  window.addEventListener("touchstart", updateState, { once: true });
  window.addEventListener("mousedown", updateState, { once: true });
}

const subscribe = (onStoreChange: () => void) => {
  listeners.add(onStoreChange);
  return () => {
    listeners.delete(onStoreChange);
  };
};

const getSnapshot = () => globalIsInteracting;

const getServerSnapshot = () => false;

function useInteractionStart() {
  const isInteracting = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot,
  );

  return { isInteracting };
}

export default useInteractionStart;
